module.exports = "<nav class=\"navbar\">\n  <div class=\"nav-links\">\n    <a ui-sref=\"main.user\">Usuarios</a>\n    <a ui-sref=\"main.premium\">Premiums</a>\n    <a ui-sref=\"main.post\">Productos</a>\n    <span flex></span>\n    <a href ng-click=\"$ctrl.logOut()\">Salir</a>\n  </div>\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/navbar/navbar.html
// module id = 431
// module chunks = 0